module.exports = "tr {\r\n\tcursor: pointer; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/instruments/instrument-list/instrument-list.component.css
// module id = ./src/app/instruments/instrument-list/instrument-list.component.css
// module chunks = main